import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import WhatWeDo from "@/components/WhatWeDo";
import Gallery from "@/components/Gallery";
import Packages from "@/components/Packages";
import Marquee from "@/components/Marquee";
import Disclaimer from "@/components/Disclaimer";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F4F3EF] text-[#0D0D0D] antialiased">
      <Toaster position="bottom-center" />
      <Nav />
      <main>
        <Hero />
        <WhatWeDo />
        <Gallery />
        <Packages />
        <Marquee />
        <Disclaimer />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
